import React, { useEffect, useState } from 'react';
import useModalStore from '../StatesStore/ModalStore';
import { Modal } from 'react-bootstrap';

import { collection, doc, getDocs, getDoc, where, query } from 'firebase/firestore';
import { db } from '../FirebaseConfig';
import ProfilePicture from '../UserProfile/ProfilePicture';
import { Link, useNavigate } from 'react-router-dom';

function FollowersModal() {
    const { closeModal, data } = useModalStore();
    const [followers, setFollowers] = useState([]);
    const [filteredFollowers, setFilteredFollowers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchFollowers = async () => {
            try {
                // Get the following subcollection for the current user
                const followingRef = collection(db, 'users', data?.uid, 'followers');
                const q = query(followingRef, where("type", "==", "user"));
                const followingSnapshot = await getDocs(q);

                // Get user data for each follower
                const followersData = await Promise.all(
                    followingSnapshot.docs.map(async (user) => {
                        const userRef = doc(db, 'users', user.id);
                        const userSnap = await getDoc(userRef);
                        return {
                            uid: user.id,
                            ...userSnap.data()
                        };
                    })
                );

                setFollowers(followersData);
                setFilteredFollowers(followersData);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching followers:", error);
                setLoading(false);
            }
        };

        if (data?.uid) {
            fetchFollowers();
        }
    }, [data?.uid]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredFollowers(followers);
        } else {
            const filtered = followers.filter(follower =>
                follower.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                follower.userTitle?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredFollowers(filtered);
        }
    }, [searchTerm, followers]);

    const handleProfileClick = (follower) => {
        closeModal();
        navigate(follower?.cover
            ? `/BrandHome/${follower.uid}`
            : `/userProfile/${follower.uid}`
        );
    };

    return (
        <>
            <style jsx>
                {`
                    .primaryModal .modal-content {
                        border-radius: 20px !important;
                        overflow: hidden;
                        max-height: 80vh; /* Set maximum height relative to viewport */
                    }
                    
                    .primaryModal .modal-dialog {
                        // max-width: 32rem;
                        margin: 1rem auto; /* Add some margin */
                    }
                    
                    .modal-backdrop {
                        z-index: 1060 !important;
                    }
                    
                    .search-input {
                        width: 100%;
                        padding: 0.5rem 1rem;
                        border: 1px solid #C3C3C3;
                        border-radius: 8px;
                        
                    }
                    
                    .follower-item {
                        display: flex;
                        align-items: center;
                        padding: 0.4rem 0;
                    }
                    
                    .followers-list {
                        max-height: calc(80vh - 200px); 
                        overflow-y: auto;
                        padding-right: 8px; 
                    }
                    
                    /* Custom scrollbar styling */
                    .followers-list::-webkit-scrollbar {
                        width: 6px;
                    }
                    
                    .followers-list::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 10px;
                    }
                    
                    .followers-list::-webkit-scrollbar-thumb {
                        background: #888;
                        border-radius: 10px;
                    }
                    
                    .followers-list::-webkit-scrollbar-thumb:hover {
                        background: #555;
                    }
                `}
            </style>
            <Modal
                show
                onHide={closeModal}
                centered
                className="primaryModal"
            >
                <Modal.Body style={{ padding: "2.1rem " }}>
                    <div className="d-flex flex-column">
                        <div className="d-flex w-100 justify-content-between">
                            <div style={{
                                fontFamily: 'Inter',
                                color: "#101828",
                                fontWeight: 600,
                                fontSize: '20px',
                                paddingBottom: '16px'
                            }}>
                                Followers
                            </div>
                            <button
                                type="button"
                                style={{
                                    boxSizing: "border-box",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "27px",
                                    height: "27px",
                                    background: "#FFFFFF",
                                    border: "1px solid #FF3B30",
                                    boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                                    borderRadius: "25px",
                                    flex: "none",
                                    order: "1",
                                    flexGrow: "0",
                                }}
                                onClick={closeModal}
                            >
                                <svg
                                    style={{ width: "11px" }}
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13 1L1 13M1 1L13 13"
                                        stroke="#FF3B30"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                        {followers.length >= 6 && (
                            <input
                                type="text"
                                className="search-input mb-3"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        )}
                    </div>

                    <div className="followers-list">
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>
                        ) : filteredFollowers.length > 0 ? (
                            filteredFollowers.map((follower) => (
                                <div key={follower.uid} className="follower-item" onClick={() => handleProfileClick(follower)}>
                                    <div className="avatar-xs me-2 mb-0" style={{ cursor: 'pointer' }}>

                                        <ProfilePicture userData={follower} avatarSize={42} />

                                    </div>
                                    <div>
                                        <div className="follower-name" style={{
                                            fontFamily: 'Inter',
                                            color: "#000000",
                                            fontWeight: 600,
                                            fontSize: '16px',
                                            lineHeight: '1.3',
                                            cursor: 'pointer'
                                        }}>

                                            {follower.userName || 'Unknown User'}

                                        </div>

                                        <div className="follower-bio" style={{
                                            fontFamily: 'Inter',
                                            color: "#676A79",
                                            fontWeight: 400,
                                            fontSize: '12px',
                                            lineHeight: '1.3',
                                            cursor: 'pointer'
                                        }}>
                                            {follower.userTitle || 'No bio available'}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                {searchTerm ? 'No matching followers found' : 'No followers found'}
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default FollowersModal;